import React, { useState, useContext } from "react";
import { Modal } from "antd";
import RectangleSelector from "ui/alerts/img-search/rectangleSelector";
import { uploadSign } from "pages/service";
import { showToast } from "ui/components/common";
import { getGptImageDesc } from "pages/dashboard/database/service";
import { AlertDataType } from "lib/types";

export default function AlertToDatabaseModal({
  activeAlert,
  isOpen,
  onRequestClose,
  onFinish,
}: {
  activeAlert: AlertDataType;
  isOpen: boolean;
  onRequestClose: () => void;
  onFinish: (imgBlob) => void;
}) {
  const [submitting, setSubmitting] = useState(false);
  const [imgBlob, setImgBlob] = useState<Blob | null>(null);
  const handleCropImg = async (img: Blob) => {
    setImgBlob(img);
  };

  const handleConfirm = async () => {
    setSubmitting(true);

    onFinish(imgBlob);
    setSubmitting(false);
    showToast(0, "Image uploaded successfully");
  };

  return (
    <Modal
      centered
      open={isOpen}
      onCancel={onRequestClose}
      footer={null}
      title={<span className="title">Select Area for Record</span>}
      width={1200}
      destroyOnClose={true}
    >
      <div className="h-[651px] flex items-center justify-center relative mt-4">
        <RectangleSelector
          imgUrl={activeAlert?.snapshot?.url}
          onCropImg={handleCropImg}
        />
        {submitting && (
          <div className="absolute top-0 left-0 w-full h-full z-10 flex flex-col items-center justify-center text-white gap-2">
            <div
              className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
            <p className="text-lg">Uploading</p>
          </div>
        )}
      </div>
      <div className="flex justify-end items-center mt-4">
        <button
          disabled={submitting}
          aria-disabled={submitting}
          className="ml-4 rounded-2xl px-6 py-4 bg-blue-500 text-sm font-medium text-white transition-colors hover:bg-blue-400 disabled:bg-transparent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
          onClick={handleConfirm}
        >
          Confrim
        </button>
      </div>
    </Modal>
  );
}
